/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
    IcecontrolSettings,
    IcemattableSettings,
    IcepanelgroupSettings,
    IcepanelsectionSettings,
    IcepanelSettings,
    IcepanelcontainerRowSettings,
    IcepanelcontainerSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcecontrolComponent } from '../../../../icemedx-lib/src/components/icepanel/icecontrol.component';
import { IcematgridComponent } from '../../../../icemedx-lib/src/components/icepanel/icematgrid.component';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { PatientKioskService } from '../../../../icemedx-lib/src/services/patientkiosk/patientkiosk.service'
import { patientindex } from '../../../../icemedx-lib/src/models/domain/patientindex';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { contact } from '../../../../icemedx-lib/src/models/common/contact';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { entity } from "../../../../icemedx-lib/src/models//common/entity";
import { AppService } from '../app.service';

@Component({
    selector: 'app-fullprofile',
    templateUrl: './fullprofile.component.html',
    styleUrls: ['./fullprofile.component.scss'],
    providers: [IcepanelService]
})
export class FullprofileComponent implements OnInit {

    patient: patient = null;

    @Input() onBackButtonClick: Function = (settings) => {
        this.router.navigate([this.appsvc.getBaseRoutePath('nameofpatient')]);
    }

    @Input() onContinueButtonClick: Function = (settings) => {
        this.router.navigate([this.appsvc.getBaseRoutePath('reasonforadmission')]);
    }

    @Input() onDateofBirthChange: Function = (settings) => {

    }
    title = 'app';
    patientIndex: patientindex;
    inboxSettings: IcepanelcontainerSettings = null;

    constructor(private router: Router, private patientKioskService: PatientKioskService, private appsvc: AppService) { }

    ngOnInit() {
        var patientDetails = JSON.parse(sessionStorage.getItem("patientDetails"));
        if (patientDetails !== null) {
            this.patientIndex = patientDetails;
        } else {
            this.patientIndex = new patientindex();
        }
        let panelTag = "FullProfile";
        let panelKey = Iceutility.guid(false);

        let controls: IcecontrolSettings[] = [
            new IcecontrolSettings("iceinput", { placeholder: "First name", value: this.patientIndex.first_name }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Last name", value: this.patientIndex.last_name }, null, null),
            new IcecontrolSettings("icedatepicker", { placeholder: "Date of birth", value: this.patientIndex.dob }, null, { change: this.onDateofBirthChange }),
            new IcecontrolSettings("iceinput", { placeholder: "Phone", value: this.patientIndex.communication_number1 }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Email", value: this.patientIndex.communication_number2 }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "State ID number", value: this.patientIndex.first_name }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Gender", value: this.patientIndex.sex }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Title", value: "" }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Middle Initial", value: "" }, null, null),
            new IcecontrolSettings("iceinput", { placeholder: "Suffix", value: this.patientIndex.suffix }, null, null),
            new IcecontrolSettings("icebutton", { text: "Back", class: ["btn-danger"], glyphClass: "fa-plus-circle" }, null, { onClick: this.onBackButtonClick }),
            new IcecontrolSettings("icebutton", { text: "Continue", class: ["btn-danger"], glyphClass: "fa-plus-circle" }, null, { onClick: this.onContinueButtonClick })
        ];

        let sections: IcepanelsectionSettings[] = [
            new IcepanelsectionSettings(
                "InboxSection",
                {
                    class: ["yalla"],
                    styles: {
                        width: "100%"
                    }
                },
                null,
                controls,
                null)
        ];
        let panels: IcepanelSettings[] = [
            new IcepanelSettings(panelTag, panelKey, "Patient Kiosk - Full profile", "", sections)];

        let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
        this.inboxSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
    }

    InsertPatient() {
        var pt_obj = new patient();
        var cont = null;
        pt_obj["entity_key"] = Iceutility.guid(true);
        pt_obj["offline_record_status"] = IceTypes.offlineRecStatus.offlineInsert;

        var ent = new entity();
        ent["entity_key"] = pt_obj["entity_key"];
        ent["first_name"] = "";
        ent["last_name"] = "";
        ent["dob"] = 1;//Iceutility.ConvertToUTC(new Date(), false);
        ent["initial"] = "";
        ent["additional_name"] = "";
        ent["offline_record_status"] = IceTypes.offlineRecStatus.offlineInsert;

        if (this.patientIndex.communication_number1 != "") {
            cont = new contact();
            cont["contact_key"] = Iceutility.guid(true);
            cont["communication_number"] = 1234567890;
            cont["communication_number_qualifier"] = "TE";
            pt_obj["CONS"] = [cont];
        }

        if (this.patientIndex.communication_number2 != "") {
            cont = new contact();
            cont["contact_key"] = Iceutility.guid(true);
            cont["communication_number"] = "";
            cont["communication_number_qualifier"] = "EM";

            if (pt_obj.hasOwnProperty("CONS")) {
                pt_obj["CONS"].push(cont);
            } else {
                pt_obj["CONS"] = [cont];
            }
        }
        let gender = this.patientIndex.sex;
        switch (gender) {
            case "Male":
                gender = "M";
                break;
            case "Female":
                gender = "F";
                break;
            case "Unknown":
                gender = "U";
                break;
        }

        ent["sex"] = gender
        pt_obj["ENTS"] = [ent];

        this.patientKioskService.insertPatient(patient);
    }

    OnBackButtonClick() {
        this.router.navigate(['/']);
    }
}
